 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"66a6ecae7a4f58989cb4451bcc9e8fdc791eafdc","2":"1433a37d19c38b79d3723093fefb3f00d7b0da1d","3":"05705d21b4537571a17158ba09a8692ed250b06d","4":"34de4dea1d4305d33d3c32fd7485935f6eee38db","5":"5c9bb9e0f0a0ad07726cd6e2ddb722c4af47685f","6":"b1a5e4698a58a8b9958042a08ac3e29b1210f413","7":"e3ee40dc807edf51634bffca17d697a2a7088e63","8":"18f48b04f0785c0c5902471c861940f076768446","9":"1c7b7806bb988d47b3a90531456c669b0e9deb3e","10":"b53fe943b69b66368ce4841cd09b5137ee634895","11":"bd76d055ea40d678403e5c9791feb7d13a94bd55","14":"component---src-pages-2019-03-nec-cb-20-js","15":"component---src-pages-2019-03-nec-cb-21-js","16":"component---src-pages-2019-03-nec-cb-22-js","17":"component---src-pages-2019-03-nec-index-js","18":"component---src-pages-2019-12-year-in-review-index-js","19":"component---src-pages-2020-34-st-election-index-js","20":"component---src-pages-2020-election-index-js","21":"component---src-pages-2020-final-issue-index-js","22":"component---src-pages-2020-giving-tuesday-index-js","23":"component---src-pages-2020-housing-guide-index-js","24":"component---src-pages-2020-join-index-js","25":"component---src-pages-2020-nec-cb-21-js","26":"component---src-pages-2020-nec-cb-22-js","27":"component---src-pages-2020-nec-cb-23-js","28":"component---src-pages-2020-nec-index-js","29":"component---src-pages-2020-welcome-back-index-js","30":"component---src-pages-2020-year-book-index-js","31":"component---src-pages-2021-best-of-penn-js","32":"component---src-pages-2021-fifty-two-faces-js","33":"component---src-pages-2021-join-js","34":"component---src-pages-2021-nec-cb-22-js","35":"component---src-pages-2021-nec-cb-23-js","36":"component---src-pages-2021-nec-cb-24-js","37":"component---src-pages-2021-nec-fall-cb-js","38":"component---src-pages-2021-nec-fall-index-js","39":"component---src-pages-2021-nec-index-js","40":"component---src-pages-2022-join-js","41":"component---src-pages-2022-nec-cb-26-js","42":"component---src-pages-2022-nec-index-js","43":"component---src-pages-2022-welcome-to-penn-js","44":"component---src-pages-2023-join-js","45":"component---src-pages-2023-nec-cb-27-js","46":"component---src-pages-2023-nec-index-js","47":"component---src-pages-2023-nec-legacy-cb-24-js","48":"component---src-pages-2023-nec-legacy-cb-25-js","49":"component---src-pages-2023-nec-legacy-cb-26-js","50":"component---src-pages-2023-nec-legacy-index-js","51":"component---src-pages-2024-join-js","52":"component---src-pages-404-js","53":"component---src-pages-clients-william-schoepe-properties-index-js","54":"component---src-pages-index-js"}[chunkId]||chunkId) + "-" + {"0":"b961c602a17024393896","1":"854698d0090e90ec6d7b","2":"bca395244590fb0d3993","3":"6e586fae735a8938c592","4":"3d31366bb846a449af99","5":"b66033d6b5aee2990af6","6":"9573380b868fd15a0c36","7":"4ba382295cfa78741a9c","8":"e5bfd74f880ca411d806","9":"cafe0530a7a8e0f90c3b","10":"2512477e85e88d14bf95","11":"2b887c62b57bca10a83a","14":"a0f3fb7f71b10d85101e","15":"08fecbea06614ffaccc7","16":"724d3d71b2293b709d93","17":"dd0e91e8ab53e3f68a9a","18":"caadd5aaf17867c49aad","19":"fb0e74fcedffc584ce32","20":"4d7b6c496571a33f409e","21":"60a4b4bb045de69307e0","22":"cf2e2aa40f8cf368107b","23":"556c0f8482691636d5f8","24":"afadfba8df196dcd4171","25":"fc955bfae0663e66314f","26":"971607301e2e46e878b4","27":"7170f8288a1f67795dfd","28":"3b01a18f6f2215e0d059","29":"0e39e5f1dfac36ed5c6c","30":"a6ae441127903b8a97eb","31":"2767e9051bbf971dcca2","32":"ef76fee6e9c306bfd2e6","33":"6709820abeb2dacaf907","34":"83571e92268412c9824e","35":"1aac746e7c6d7807f2e1","36":"dfcc98ecd7e55d21ba39","37":"185297af94ee73a71abe","38":"b9434360b47dd7c08082","39":"1d4aeec10f19f16e226f","40":"740864b9d533ea77856a","41":"516890a636650ad41848","42":"399b72f963c9af887242","43":"8915580343729464d3d9","44":"4f7bcba9697fc6245b14","45":"432ffe4794faca0ddd39","46":"ce168c9345cbed2364f3","47":"511a869a7df3063d8f69","48":"57711be496e82dd1426f","49":"99389f1e1f9f3462dfea","50":"26066c4e69fc2dfeb575","51":"3fedda8fb932caeec506","52":"93852d6762fc54cd67ef","53":"7a111c26f1d6f50ad44b","54":"f8bb31228ad1ab5abea6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
